module.exports = __webpack_public_path__ + "img/9788983923622.b12c1c6e.jpg";